import React,{Component} from 'react';
import { NavLink } from 'react-router-dom';
import Trends from './partials/Trends';
import Footer from './partials/Footer';

class Signals extends React.Component {

    componentWillMount () {
        
        const script1 = document.createElement("script");
   
     // script1.src = "/assets/js/slick.min.js";
      script1.src = "/assets/js/main.js";
      script1.async = true;
   
      document.body.appendChild(script1);
       
      }
      
   render(){
 
    return(
        <div>
       
        <div class="main-banner companybg newonetop signals">
        <div class="signalsinner">
        <div class="container bo">
                <img src="assets/images/top-banner-below-3-3px.svg" class="middlediv container" />
                </div>
                <div class="container">
                <img src="assets/images/top-banner-below-3-3px.svg" class="middlediv container" />
                 <header class="main-header d-flex justify-content-between">
                              <div class="site-logo">
                                 
                                 <NavLink to="/"> <img src="assets/images/openpoint_logo.png" class="logotop" /></NavLink>
                              </div>
                              <div class="menu-toggle-icon">
                                 <span class="hamburger-inner"></span>
                              </div>
                              <div class="site-login">
                                 <div class="menu-toggle-bg"></div>
                                 <div class="site-login-inner">
                                    <div class="site-logo menu-with-logo">
                                        <NavLink to="/"><img src="assets/images/openpoint_logo.png" class="logotop" /></NavLink>
                                    </div>
                                     
                                    <a href="/quote" className="mr-4 top-link mobi" id="get-start">Get a Quote</a>
                                     <NavLink to="/signals" className="mr-4 top-link mobi" >Signals</NavLink>
                                    
                                   <NavLink to="/" className="mr-4 top-link desk">Home</NavLink>
                                    <NavLink to="/signals" className="mr-4 top-link desk">Signals</NavLink>
                                                                            <NavLink to="/careers" className="mr-4 top-link">Careers</NavLink>
                                                                            
                                                                            <NavLink to="/company" className="mr-4 top-link">Company</NavLink> 
                                                                            {/* <NavLink to="/" className="mr-4 top-link desk">Login</NavLink> */}
                                    <NavLink to="/quote" className="btn btn-lg btn-flat btn-outline ml-3 desk get33">Get a Quote</NavLink>
                                 </div>
                              </div>
                           </header>
                
            <div class="row justify-content-center">
               <div class="col-md-9">
               <div class="banner-content text-center comp">
                     <h1 class="banner-title">Lorem Ipsum</h1>
                     <div class="banner-description">
                        <p><span class="freet" >Lorem Ipsum is simply dummy text of the printing</span></p>
                     </div>
                    
                     </div>
               <div>
                   <p class="ptext">
                   Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
                   labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco 
                   laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in 
                   voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat 
                   non proident, 
                   sunt in culpa qui officia deserunt mollit anim id est laborum
                   </p>
               </div>
               
               </div> </div>  </div> </div> </div> 

               <div class="call-to-action container combg">
                <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-7">
                        <div class="pl-5">
                            <h2 class="freeh2">Lorem Ipsum</h2>
                            <p class="pclass">Lorem Ipsum is simply dummy text of the printing.</p>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="buttonstart">
                        <NavLink to="/quote" className="btn btn-lg btn-flat btn-dark">Get a Quote
                        <svg focusable="false" class="ibm-duo-u--link-icon--arrow-right" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" slot="icon"><path d="M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"></path></svg>
                        </NavLink> </div>
                    </div>
                </div>
                </div>
                </div>
               

               <section id="top" data-section-id="mnutwt" data-section="main" class="upflow-12 pt-2 pb-6 custom text-center bg-center headlines-dark">
    <div class="container" data-section-container-main="mnutwt">
        <div data-section-row-main="mnutwt" class="row flex-row justify-content-center align-items-center">
          
            <div class="col col-cards col-12 py-2 py-md-4">
                <div class="col-inside col-inside-cards text-center list-">
                    <div class="row flex-row row-cards justify-content-center justify-content-md-around">
                        <div class="col col-card col-12 col-sm-10 col-md-6 col-lg-4">
                            <div class="col-inside col-inside-card h-100 py-2">
                                <a class="wrapper-link card-wrapper-link" href="javascript:void(0)" >
                                    <div class="card h-100 d-flex flex-column justify-content-md-between dropshadow no-border top-border-6px text-left hl-sm card-icon-image-left border-dark">
                                        <div class="wrapper-card-content d-flex justify-content-md-between h-100 flex-row">
                                            <figure class="figure figure-cards w-100">
                                                <img
                                                    class="lazy image img-fluid figure-img icon-image rounded-circle card-img-top loaded"
                                                    alt="1"
                                                    src="assets/images/fitness_insights.jpg"
                                                />
                                            </figure>

                                            <div class="card-body d-flex flex-column h-100 justify-content-between">
                                                <div class="d-flex flex-column h-100 justify-content-md-start">
                                                    <h5 class="headline headline-col headline-col-cards">
                                                        <span class="superheadline">Live Event</span>

                                                        Lorem Ipsum
                                                    </h5>

                                                    <div class="">
                                                        <p>Lorem Ipsum is simply dummy text of the printing.</p>
                                                    </div>
                                                </div>

                                                <div class="buttons buttons-cards">
                                                    <div class="link link-primary icon-after wrapped-link">
                                                        Register Now
                                                        <svg
                                                            class="svg-inline--fa fa-arrow-right fa-w-14"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            data-prefix="fal"
                                                            data-icon="arrow-right"
                                                            role="img"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 448 512"
                                                            data-fa-i2svg=""
                                                        >
                                                            <path
                                                                fill="currentColor"
                                                                d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z"
                                                            ></path>
                                                        </svg>
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col col-card col-12 col-sm-10 col-md-6 col-lg-4">
                            <div class="col-inside col-inside-card h-100 py-2">
                                <a class="wrapper-link card-wrapper-link" href="javascript:void(0)" >
                                    <div class="card h-100 d-flex flex-column justify-content-md-between dropshadow no-border top-border-6px text-left hl-sm card-icon-image-left border-dark">
                                        <div class="wrapper-card-content d-flex justify-content-md-between h-100 flex-row">
                                            <figure class="figure figure-cards w-100">
                                                <img
                                                    class="lazy image img-fluid figure-img icon-image rounded-circle card-img-top loaded"
                                                    alt="1"
                                                    src="assets/images/fitness_insights.jpg"
                                                />
                                            </figure>

                                            <div class="card-body d-flex flex-column h-100 justify-content-between">
                                                <div class="d-flex flex-column h-100 justify-content-md-start">
                                                    <h5 class="headline headline-col headline-col-cards">
                                                        <span class="superheadline">Live Event</span>

                                                        Lorem Ipsum
                                                    </h5>

                                                    <div class="">
                                                        <p>Lorem Ipsum is simply dummy text of the printing.</p>
                                                    </div>
                                                </div>

                                                <div class="buttons buttons-cards">
                                                    <div class="link link-primary icon-after wrapped-link">
                                                        Register Now
                                                        <svg
                                                            class="svg-inline--fa fa-arrow-right fa-w-14"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            data-prefix="fal"
                                                            data-icon="arrow-right"
                                                            role="img"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 448 512"
                                                            data-fa-i2svg=""
                                                        >
                                                            <path
                                                                fill="currentColor"
                                                                d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z"
                                                            ></path>
                                                        </svg>
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div class="col col-card col-12 col-sm-10 col-md-6 col-lg-4">
                            <div class="col-inside col-inside-card h-100 py-2">
                                <a class="wrapper-link card-wrapper-link" href="javascript:void(0)" data-g-action="" data-g-label="">
                                    <div class="card h-100 d-flex flex-column justify-content-md-between dropshadow no-border top-border-6px text-left hl-sm card-icon-image-left border-dark">
                                        <div class="wrapper-card-content d-flex justify-content-md-between h-100 flex-row">
                                            <figure class="figure figure-cards w-100">
                                                <img
                                                    class="lazy image img-fluid figure-img icon-image rounded-circle card-img-top loaded"
                                                    alt="1"
                                                    src="assets/images/fitness_insights.jpg"
                                                />
                                            </figure>

                                            <div class="card-body d-flex flex-column h-100 justify-content-between">
                                                <div class="d-flex flex-column h-100 justify-content-md-start">
                                                    <h5 class="headline headline-col headline-col-cards">
                                                        <span class="superheadline">Live Event</span>

                                                        Lorem Ipsum
                                                    </h5>

                                                    <div class="">
                                                        <p>Join us and industry leaders to discuss the state of the advertising industry now and in the future.</p>
                                                    </div>
                                                </div>

                                                <div class="buttons buttons-cards">
                                                    <div class="link link-primary icon-after wrapped-link">
                                                        Register Now
                                                        <svg
                                                            class="svg-inline--fa fa-arrow-right fa-w-14"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            data-prefix="fal"
                                                            data-icon="arrow-right"
                                                            role="img"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 448 512"
                                                            data-fa-i2svg=""
                                                        >
                                                            <path
                                                                fill="currentColor"
                                                                d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z"
                                                            ></path>
                                                        </svg>
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                      
                      </div>
                </div>
            </div>
           
        </div>
    </div>
</section>

                <section id=""  class="py-0 hl-sm bg-white-to-lighter text-left bg-cover bg-top bottomseccomp signlebo">
<div class="jsx-3566695915 jsx-1766729656 basic-attributes-container">
    <div class="jsx-3566695915 jsx-1766729656 left-column">
        <h3 class="jsx-3566695915 jsx-1766729656">Lorem Ipsum </h3>
        <p class="jsx-3566695915 jsx-1766729656 basic-attribute-cta">Lorem Ipsum is simply dummy text of the printing.</p>
        <div class="jsx-3566695915 jsx-1766729656 basic-pills">
            <span data-attr-index="0" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill selected-basic-attribute">
                Enigma ID
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">Lorem Ipsum is simply dummy text of the printing.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
            <span data-attr-index="1" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill">
                Phone Numbers
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">A list of phone numbers associated with the matched business.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
            <span data-attr-index="2" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill">
                Registered Agents
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">A list of registered agent names wherein the business is designated to receive the service of a process related to a legal matter.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
            <span data-attr-index="3" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill">
                Website
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">A list of websites associated with the matched business.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
            <span data-attr-index="4" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill">
                Corporate Structure
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">The legal structure under which the business is incorporated.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
            <span data-attr-index="5" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill">
                Founded
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">Year of earliest incorporation date found in our sources.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
            <span data-attr-index="6" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill">
                Registrations
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">The states and corresponding registration dates for state-level corporate registrations found in Enigma’s data sources.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
            <span data-attr-index="7" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill">
                Addresses
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">The various addresses for the business found in Enigma’s data sources.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
            <span data-attr-index="8" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill">
                Aliases
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">A list of aliases associated with the business.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
            <span data-attr-index="9" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill">
                Associated People
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">A list of related people and their relation to the matched business.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
            <span data-attr-index="10" class="jsx-3566695915 jsx-1766729656 basic-attribute-pill">
                EIN
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">Employee Identification Numbers is the Tax Identification Number associated to the company.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </span>
        </div>
    </div>
    <div class="jsx-3566695915 jsx-1766729656 right-column">
        <div class="jsx-3566695915 jsx-1766729656 basic-attribute-explanation">
            <div class="jsx-3566695915 jsx-1766729656">
                <h4 class="jsx-3566695915 jsx-1766729656">Lorem Ipsum</h4>
                <p class="jsx-3566695915 jsx-1766729656 attribute-explanation">Lorem Ipsum is simply dummy text of the printing.</p>
                <a href="#" class="jsx-3566695915 jsx-1766729656 learn-more-link">
                    <span class="jsx-3566695915 jsx-1766729656">Learn More</span>
                    <div class="jsx-2248216861 wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="jsx-2248216861">
                            <path d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z" fill="#181818" class="jsx-2248216861"></path>
                        </svg>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
<div class="jsx-974646815 jsx-1830892795 section section--enter">
    <div class="jsx-974646815 jsx-1830892795 section-inner">
        <div class="jsx-1512039926 container">
            <div class="jsx-2381861348 split-text">
                <div class="jsx-2381861348 inner-wrapper">
                    <div class="jsx-2381861348 headline-wrapper">
                        <div class="jsx-2381861348 headline-inner-wrapper">
                            <span class="jsx-2381861348 icon">
                                <figure class="jsx-3482758541 figure">
                                    <picture class="jsx-3482758541">
                                        <img
                                            src="assets/images/Icon_Our-Data_Raw_Data.gif"
                                            alt="Collecting raw data icon"
                                            class="jsx-3482758541 -animate-in image"
                                        />
                                    </picture>
                                </figure>
                            </span>
                            <div class="jsx-2381861348 headline">
                                <h2 class="jsx-3776472470 jsx-3690373773 heading4 extraStyles">What is Lorem Ipsum?</h2>
                            </div>
                        </div>
                    </div>
                    <div class="jsx-2381861348 body-wrapper">
                        <div class="jsx-2381861348 body">
                            <div class="rich-text">
                                <p>
                                   Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="jsx-974646815 jsx-1830892795 section section--enter">
    <div class="jsx-974646815 jsx-1830892795 section-inner">
        <div class="jsx-1512039926 container">
            <div class="jsx-2381861348 split-text">
                <div class="jsx-2381861348 inner-wrapper">
                    <div class="jsx-2381861348 headline-wrapper">
                        <div class="jsx-2381861348 headline-inner-wrapper">
                            <span class="jsx-2381861348 icon">
                                <figure class="jsx-3482758541 figure">
                                    <picture class="jsx-3482758541">
                                        <img
                                            src="assets/images/Icon_Our-Data_Attributes.gif"
                                            alt="Collecting raw data icon"
                                            class="jsx-3482758541 -animate-in image"
                                        />
                                    </picture>
                                </figure>
                            </span>
                            <div class="jsx-2381861348 headline">
                                <h2 class="jsx-3776472470 jsx-3690373773 heading4 extraStyles">What is Lorem Ipsum?</h2>
                            </div>
                        </div>
                    </div>
                    <div class="jsx-2381861348 body-wrapper">
                        <div class="jsx-2381861348 body">
                            <div class="rich-text">
                                <p>
                                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="jsx-974646815 jsx-1830892795 section section--enter">
    <div class="jsx-974646815 jsx-1830892795 section-inner">
        <div class="jsx-1512039926 container">
            <div class="jsx-2381861348 split-text">
                <div class="jsx-2381861348 inner-wrapper">
                    <div class="jsx-2381861348 headline-wrapper">
                        <div class="jsx-2381861348 headline-inner-wrapper">
                            <span class="jsx-2381861348 icon">
                                <figure class="jsx-3482758541 figure">
                                    <picture class="jsx-3482758541">
                                        <img
                                            src="assets/images/Icon_Our-Data_Validate.gif"
                                            alt="Collecting raw data icon"
                                            class="jsx-3482758541 -animate-in image"
                                        />
                                    </picture>
                                </figure>
                            </span>
                            <div class="jsx-2381861348 headline">
                                <h2 class="jsx-3776472470 jsx-3690373773 heading4 extraStyles">
What is Lorem Ipsum?</h2>
                            </div>
                        </div>
                    </div>
                    <div class="jsx-2381861348 body-wrapper">
                        <div class="jsx-2381861348 body">
                            <div class="rich-text">
                                <p>
                                   
                              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                              </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



</section>
                

                <div class="g-call-to-action variant-compact theme-light">
    <div class="g-grid-container">
        <h2 data-testid="heading" class="g-type-display-2">What is Lorem Ipsum?</h2>
        <div class="content-and-links">
            <p data-testid="content" class="g-type-body-large">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
            <div data-testid="links" class="links">
                <a class="g-btn size-medium variant-primary background-light" data-ga-button="contact-sales" href="#"><span class="text g-type-buttons-and-standalone-links">Contact Sales</span></a>
                <a class="g-btn size-medium variant-secondary background-light" data-ga-button="request-demo" href="#"><span class="text g-type-buttons-and-standalone-links">Request Demo</span></a>
            </div>
        </div>
    </div>
</div>
                    <Footer />
<div class="row -center hero-row popupde">
    <div class="close2">
        <a class="close-atag" href="javascript:void(0);">
            <img src="assets/images/xlose.png" />
        </a>
    </div>
<img class="feature-callout__img" src="https://luna1.co/005100.png" alt="Image of team" width="112" />
            <div class="signupForm-homepage-center col-xsmall-12 col-small-8 col-small-offset-2 col-medium-10 col-medium-offset-1 col-large-8 col-large-offset-2 col-xlarge-6 col-xlarge-offset-3">
                <h4 class="heading -spacing-2 -h3">Sign up</h4>
                <p class="subheading -spacing-1 hero-legal-copy">
                    By signing up, I agree to the Asana <a href="/terms#privacy-policy" class="css-1kfjk3x-Link">Privacy Policy</a> and <a href="/terms#terms-of-service" class="css-1kfjk3x-Link">Terms of Service</a>.
                </p>
                <form action="get-started/verify" method="get" novalidate="" class="signupForm hidden-logged-in signupForm-homepage-center" __bizdiag="1239199729" __biza="WJ__">
                    <div class="signupForm-container">
                        <div class="signupForm-row">
                        <div class="form-group">
                                
                                <input type="email" name="e" required  class="form-control" placeholder="name@company.com" id="work-email" />
                            </div>

                            <div class="submit-btn">
                                <button id="go-to-nextStep"  onClick={this.toggleBox} class="btn btn-lg btn-flat btn-block btn-primary">Next</button>
                            </div>
                        </div>
                    </div>
                </form>
                
            </div>
        </div>
 </div>
    );
}
}

export default Signals;